import { C } from "../data";

export default function Img({ style = {}, label, dark, src }) {
  if (src) {
    return (
      <img
        src={src}
        alt={label || ""}
        style={{ display:"block", objectFit:"cover", ...style }}
      />
    );
  }
  return (
    <div style={{
      background: dark ? "#2A2A2A" : C.white,
      border: `1px solid ${dark ? "#3A3A3A" : C.border}`,
      display:"flex", flexDirection:"column",
      alignItems:"center", justifyContent:"center", gap:8,
      ...style,
    }}>
      <div style={{
        width:28, height:28, borderRadius:"50%",
        border:`1px solid ${dark ? "#555" : C.border}`,
        display:"flex", alignItems:"center", justifyContent:"center",
      }}>
        <span style={{ fontSize:14, color: dark ? "#555" : C.border }}>+</span>
      </div>
      {label && (
        <span style={{
          fontFamily:"'Pretendard',sans-serif", fontWeight:500, fontSize:8,
          letterSpacing:2, color: dark ? "#555" : C.border,
        }}>{label}</span>
      )}
    </div>
  );
}
